import gladysPic from "@/public/images/artists/gladys.png";
import { Artist } from "@/types/types";

export const gladys = {
  id: "212",
  name: "Gladys",
  image: gladysPic,
  description: `Gladys voice is charged with energy, carrying a gritty, almost growling intensity that brings emotion to the forefront. With an old-school timbre and natural power, she brings a timeless, soulful edge, perfect for retro-inspired tracks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fgladys-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Disco", "Soul", "Dance", "Belting", "Unprocessed"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 56,
        high: 72,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
